import Vue from 'vue';
const EventBus = new Vue({
    methods: {
        alertError(mensagem) {
            this.$emit("criarAlerta", {
                snackbar: true,
                color: "error",
                text: mensagem
            });
            this.loading(false);
        },
        loading(isLoading) {
            this.$emit("change::isLoading", isLoading);
        },
        alertInfo(mensagem) {
            this.$emit("criarAlerta", {
                snackbar: true,
                color: "blue darken-4",
                text: mensagem
            });
            this.loading(false);
        }
    }
});
export default EventBus;